import { __assign, __rest } from "tslib";
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
var Error = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 15 15", fill: "currentColor", width: size || "15", height: size || "15" }, props),
        React.createElement("g", { fill: "none", fillRule: "evenodd" },
            React.createElement("path", { fill: "currentColor", d: "M7.5 1a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13zm0-1a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15z", fillRule: "nonzero" }),
            React.createElement("path", { fill: "currentColor", d: "M7.982 9h-.964V4h.964z" }),
            React.createElement("path", { fill: "currentColor", d: "M8 11H7v-1h1z" }))));
};
Error.displayName = 'Error';
export default Error;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Error.js.map